export function FileMetadataListRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.FileMetadataList', {
		url: '/fileMetadataList',
		controllerAs: 'vm',
		controller: FileMetadataListCtrl,
		templateUrl: '/ng/hub/File/MetadataList/FileMetadataListCtrl.html?' + window.BUILD,
		permission: ['login'],
		resolve: {
			$title: () => 'FileMetadataList page',
		},
	});
}

export class FileMetadataListCtrl {
	constructor($stateParams) {
		'ngInject';
		this.$stateParams = $stateParams;
		this.metadataOptions = this.$stateParams.properties;
		this.fileName = this.$stateParams.fileName;
		this.selectedProperties = [];
		this.setup();
	}

	setup() {
		// Purely for display purposes, determines whether to show content or error message
		if (this.metadataOptions.length > 0) {
			this.hasOptions = true;
		} else {
			this.hasOptions = false;
		}
	}

	save() {
		const matches = [];
		this.selectedProperties.map(item => {
			let match = this.metadataOptions.find(option => {
				return item === option.id;
			});
			return matches.push(match);
		});
		// send matches back to modal
		this.$resolve(matches);
	}
}
